import React from "react";
import styled from "styled-components";
import previewPage from "../../../../../assets/WebsiteBuilder/previewPage.jpg";

const StyledPreviewModal = styled.div`
    width: 100%;
    border-radius: 20px;
    padding: 20px;
    background-color: #313131;
    .preview-wrap {
        max-height: 60dvh;
        overflow-y: auto;
        img {
            width: 100%;
        }
    }
`;

const PreviewModal = () => {
    return (
        <StyledPreviewModal>
            <div className="preview-wrap">
                <img src={previewPage} alt="previewPage" />
            </div>
        </StyledPreviewModal>
    );
};

export default PreviewModal;
